import asyncComponent from 'react-imported-component'
import ErrorComponent from './ErrorComponent'

const AsyncComponent = (loader) => asyncComponent(loader, { ErrorComponent })

export default AsyncComponent
